import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CenteredScrollableContentModule } from 'src/tmc-common/widgets/terminal/centered-scrollable-content/centered-scrollable-content.module';
import { TransportFurtherInfoComponent } from './transport-further-info.component';
import { ApplicationClientCommonModule, DictionaryModule, MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TransportFurtherInfoComponent
  ],
  imports: [
    CommonModule,
    CenteredScrollableContentModule,
    DictionaryModule,
    MaterialModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class TransportFurtherInfoModule { }
